<template>
  <a
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
    class="msc-video-link"
    v-b-popover.hover.top="tip"
    :aria-label="tip"
  >
    <span class="msc-video-link__glyph" aria-hidden="true">?</span>
  </a>
</template>

<script>
export default {
  name: 'video-help-link',
  props: {
    href: {
      type: String,
      required: true,
    },
    tip: {
      type: String,
      default: 'Watch help video',
    },
  },
};
</script>
